import { BrowserModule } from '@angular/platform-browser';

/* Routing */
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

/* Angular Material */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

/* FormsModule */
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/* Components */
import { AngularMaterialModule } from './shared/angular-material.module';
import { RestApiService } from './core/https/rest-api.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConsultationModule } from './modules/private/consultation/consultation.module';
import { ToasterModule } from 'angular2-toaster';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { SharedModule } from './shared/shared.module';
import { SafeHTMLPipe } from './safe-html.pipe';

@NgModule({
  declarations: [AppComponent,SafeHTMLPipe],
  imports: [
    BrowserModule,
    ConsultationModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialModule,
    HttpClientModule,
    SharedModule,
    ToasterModule.forRoot(),
  ],
  providers: [RestApiService, AuthGuard, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
